import {createEntityService} from "base/entity/service";
import {Service as DefaultService} from "app/common/service";
import {
    createCoordinationindexes,
    createCoordinationindexesList,
    coordinationindexes_api_adapter,
    coordinationindexes_list_api_adapter,
} from "app/coordinationindexes/Coordinationindexes";

const entityService = createEntityService(
    "/api/app/coordinationindexes",
    createCoordinationindexes,
    createCoordinationindexesList,
    coordinationindexes_api_adapter,
    coordinationindexes_list_api_adapter
);

export const CoordinationindexesService = DefaultService(entityService);
